import { useTranslation } from "react-i18next";
import { CardMenuList, MenuItem } from "UIPalette/CardMenuList/CardMenuList";
import { trackEvents } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";
import { CHECK_IN_OPTION_CONFIG, CheckInOutcome, SELECTION_DELAY_MS } from "../../enums/supportMoments/supportMoments";

type CheckInScreenProps = {
  onFinish: (option: CheckInOutcome) => void;
};

export const CheckInScreen = ({ onFinish }: CheckInScreenProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: "supportMoments.checkIn" });

  const handleFinish = (option: CheckInOutcome) => {
    trackEvents(EventNames.SUPPORT_MOMENTS_CHECKIN_FINISH, { value: option });
    onFinish(option);
  };

  const menuItems: MenuItem[] = Object.values(CheckInOutcome).map((option) => {
    const { Emoji, theme } = CHECK_IN_OPTION_CONFIG[option];
    return {
      emoji: Emoji,
      title: t(`options.${option}`),
      theme,
      onClick: () => handleFinish(option),
    };
  });

  return (
    <div className="space-y-10">
      <p>{t("heading")}</p>
      <CardMenuList menuItems={menuItems} timeoutDuration={SELECTION_DELAY_MS} />
    </div>
  );
};
